/** Format seconds into human-readable wait time */
export function formatWaitTime(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins < 60) return secs > 0 ? `${mins}:${String(secs).padStart(2, '0')}` : `${mins}m`;
  const hours = Math.floor(mins / 60);
  const remainMins = mins % 60;
  return `${hours}h${remainMins > 0 ? remainMins + 'm' : ''}`;
}

/** Get Tailwind color class based on station thresholds */
export function waitTimeColor(seconds: number, warn: number, urgent: number): string {
  if (urgent > 0 && seconds > urgent) return 'text-red-400';
  if (warn > 0 && seconds > warn) return 'text-yellow-400';
  return 'text-green-400';
}

/** Get border color based on station thresholds */
export function waitTimeBorderColor(seconds: number, warn: number, urgent: number): string {
  if (urgent > 0 && seconds > urgent) return 'border-red-500';
  if (warn > 0 && seconds > warn) return 'border-yellow-500';
  return 'border-gray-600';
}

/** Calculate countdown seconds from deadline_at (Unix ms). Returns null if no deadline. */
export function getCountdown(deadline_at: number | null | undefined): number | null {
  if (!deadline_at) return null;
  const remaining = Math.floor((deadline_at - Date.now()) / 1000);
  return remaining;
}

/** Format countdown: positive = "5:30", zero/negative = "超时 2:15" */
export function formatCountdown(seconds: number): string {
  const abs = Math.abs(seconds);
  const formatted = formatWaitTime(abs);
  return seconds < 0 ? `+${formatted}` : formatted;
}

/** Countdown color: green → yellow → red → flashing red */
export function countdownColor(seconds: number): string {
  if (seconds < 0) return 'text-red-500 animate-pulse';
  if (seconds < 120) return 'text-red-400';
  if (seconds < 300) return 'text-yellow-400';
  return 'text-blue-400';
}

/** Countdown border color */
export function countdownBorderColor(seconds: number): string {
  if (seconds < 0) return 'border-red-600';
  if (seconds < 120) return 'border-red-500';
  if (seconds < 300) return 'border-yellow-500';
  return 'border-blue-500';
}
